import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { Link } from "react-router-dom";

import { Text18 } from '../../ui/Text18';

export const MasetroCardLogo  = styled.img`
  margin: 0 8px 0 0;  
`;

export const LogoMobile = styled.img`
  max-height: 33px;
  padding: 0 0 0 7px;
`;

export const FooterBottomLogo = styled.img` 
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

export const JoblistLogo = styled(FooterBottomLogo)`
  padding: 0 0 0 27px; 
`;

export const NineLogo = styled(FooterBottomLogo)`
  padding: 0 0 0 140px; 
`;

export const SimpalsLogo = styled(FooterBottomLogo)`
  padding: 0 0 0 58px;
  position: relative;
  top: -8px;
`;

export const CardIcons = styled.div`
  margin: 96px 0 0 0;
  @media (max-width: 575px) {
    margin: 27px 0 0 0;
  }
`;

export const FooterBottomContainer = styled(Grid)`
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
  padding: 92px 0 148px 0;
  @media (max-width: 575px) {
    padding: 30px 0 148px 0;
  }
`;

export const FooterTopContainer = styled(Grid)` 
  padding: 0 0 52px 0;
  @media (max-width: 575px) {
    padding: 0 0 19px 0;
  }
`;

export const Footer = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.colors.gray};
  padding: 40px 0 0 0;
  margin: 40px 0 0 0;
  @media (max-width: 575px) {
    margin: 20px 0 0 0;
    padding: 22px 0 0 0;
  }
`

export const FooterMenuTitle = styled(Text18)`
  font-weight: 700;
  margin: 0 0 22px 0;
  letter-spacing: -0.45px;
  @media (max-width: 575px) {
    margin: 0 0 16px 0;
  }
`;

export const FooterContactItem = styled.div`
  display: flex;
  margin: 0 0 8px 0;
`;

export const FooterContactText = styled.div`
    color: ${({ theme }) => theme.colors.blackColor};
    margin: 0 0 0 4px;
`;

export const FooterMenuLinks = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blackColor};
  margin: 0 0 0 4px;
  &:hover {
    text-decoration: none;  
    opacity: 0.8;
  }
`;

export const RuleLink = styled(Link)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.accentBlue}; 
  margin: 0 0 9px 0;
  display: block; 
  white-space: nowrap;
  @media (max-width: 575px) {
    margin: 0 0 8px 0;
  }
  &:hover {
    text-decoration: none;  
    opacity: 0.8;
  }
`;


export const FooterItem = styled.div`
  padding: 11px 0 0 7px;
  @media (max-width: 575px) {
    padding: 17px 0 0 7px;
  }
`;

export const JuridicialItem = styled(FooterItem)`
  padding: 11px 0 0 12px;
  @media (max-width: 575px) {
    padding: 13px 0 0 7px;
  }
`;

export const RulesItem = styled(FooterItem)`
    padding: 11px 0 0 19px;
    @media (max-width: 575px) {
      padding: 20px 0 0 6px;
    }
`;